import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './header.css'

function Header() {
	const navigate = useNavigate()
	const [, setIsFixed] = useState(false)
	const [isResidencesOpen, setIsResidencesOpen] = useState(false)

	const toggleResidences = (e) => {
		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}
		setIsResidencesOpen((prev) => !prev)
	}

	const handleResidencesClick = (e) => {
		if (typeof window !== 'undefined' && window.innerWidth <= 991) {
			toggleResidences(e)
		}
	}

	const handleAboutUsClick = (e) => {
		if (typeof window !== 'undefined' && window.innerWidth > 991) {
			navigate('/aboutus')
		}
	}

	useEffect(() => {
		(function () {
			document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
				document.querySelector('.offcanvas-collapse').classList.toggle('open')
			})
		})()
	}, [])

	useEffect(() => {
		const handleScroll = () => {
			// Change to fixed header after scrolling 100px
			const scrollPosition = window.scrollY
			setIsFixed(scrollPosition > 500)
		}

		// Add scroll event listener
		window.addEventListener("scroll", handleScroll, { passive: true })

		// Clean up event listener on component unmount
		return () => {
			window.removeEventListener("scroll", handleScroll)
		}
	}, [])
	return (
		<header className="header-main" style={{ position: 'sticky', top: 0, left: 0, zIndex: 1000, width: '100%', backgroundColor: '#fff' }}>
			<nav className="navbar navbar-expand-lg" aria-label="Main navigation">
				<div className="container" style={{ maxWidth: '1250px' }}>
					<a className="navbar-brand" href="/">
						<img src="/websiteimages/au-logo-black-100.webp" srcSet="/websiteimages/au-logo-black-100.webp 1x, /websiteimages/au-logo-black-200.webp 2x, /websiteimages/au-logo-black.webp 3x" alt='AU Real Estate Logo' width={100} height={69} fetchpriority='high' />
					</a>
					<button className="navbar-toggler" type="button" id="navbarSideCollapse" aria-label="Toggle navigation">
						<img src="/images/toggle-icon.svg" alt="" width={35} height={25} />
					</button>
					<div className="navbar-collapse offcanvas-collapse" id="navbarsExampleDefault">
						<ul className="navbar-nav">
							{/* <li className="nav-item dropdown">
								<Link className="nav-link" ria-current="page" to="/aboutus">About Us</Link>
							</li> */}

							<li className="nav-item dropdown">
								<Link
									className="nav-link dropdown-toggle"
									to="/aboutus"
									id="navbarDropdown"
									role="button"
									data-bs-toggle="dropdown"
									aria-expanded="false"
									onClick={handleAboutUsClick}
								>
									About Us
								</Link>
								<ul className="dropdown-menu" aria-labelledby="navbarDropdown">
									<li><Link className="dropdown-item" to="/aboutus">About Us</Link></li>
									<li><a className="dropdown-item" href="/bbf-scholar-program" target='_blank' rel='noreferrer'>CSR</a></li>
								</ul>
							</li>
							<li className="nav-item dropdown">
								<Link className="nav-link dropdown-toggle" to="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
									Projects
								</Link>
								<ul className="dropdown-menu" aria-labelledby="navbarDropdown">
									<li className={`residencesDropdown ${isResidencesOpen ? 'open' : ''}`}>
										<div className="residences-header-row d-flex align-items-center justify-content-between">
											{/* Toggles the sub-menu on mobile; on desktop it opens on hover. Kept as a link for the existing dropdown styling. */}
											{/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */}
											<a
												className="dropdown-item residences-title"
												href="javascript:void(0)"
												role="button"
												tabIndex={0}
												onClick={handleResidencesClick}
											>
												Residences
											</a>
											{/* eslint-enable jsx-a11y/anchor-is-valid, no-script-url */}
											<button
												type="button"
												className={`residences-collapse-btn ${isResidencesOpen ? 'open' : ''}`}
												aria-label="Toggle Residences Submenu"
												aria-expanded={isResidencesOpen}
												onClick={toggleResidences}
											>
												<i className={`fa fa-chevron-down arrow-icon ${isResidencesOpen ? 'rotate-up' : ''}`} aria-hidden="true"></i>
											</button>
										</div>
										<ul className={`SubDropdown dropdown-menu ${isResidencesOpen ? 'open-mobile' : 'collapsed-mobile'}`}>
											<li><a className="SubDropdown-item dropdown-item" href="/arihant-enclave" target='_blank' rel='noreferrer'>Arihant Enclave</a></li>
											<li><a className="SubDropdown-item dropdown-item" href="/the-sunflower" target='_blank' rel='noreferrer'>The Sunflower</a></li>
											<li><a className="SubDropdown-item dropdown-item" href="/aspire-silicon-city" target='_blank' rel='noreferrer'>Aspire Silicon City</a></li>
											<li><a className="SubDropdown-item dropdown-item" href="/aspire-leisure-valley" target='_blank' rel='noreferrer'>Aspire Leisure Valley</a></li>
											<li><a className="SubDropdown-item dropdown-item" href="/cosmos-corner">Cosmos Corner</a></li>
										</ul>
									</li>
									<li><a className="dropdown-item" href="/family-hub" target='_blank'>Commercial</a></li>
								</ul>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/service">Services</Link>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/advisory">Advisory</Link>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/joint-ventures">Joint Ventures</Link>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/blogs">Blogs</Link>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/news">News</Link>
							</li>
							<li className="nav-item">
								<Link className="nav-link" to="/contactus">Contact Us</Link>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</header>
	)
}

export default Header